// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Form, TextArea } from 'informed';
import moment from 'moment';

import {
  addNurseNote,
  updateNurseNote,
  addProviderNote,
  updateProviderNote,
} from '../../../../actions/progressNoteActions';

import {
  NURSE_NOTE_TYPE,
  PROVIDER_NOTE_TYPE,
} from '../progressNoteTypes';

import { PrimaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';
import { Button, PrimaryButton } from '../../../Buttons.jsx';
import DatetimeText from '../../../DatetimeText.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  note: ?Object,
  /*
    (noteId: string, note: Object) => {}
  */
  handleSaveNote: Function,
  /*
    (note: Object) => {}
  */
  handleSaveNewNote: Function,
  activePatientId: string,
  activeAccount: Object,
  problemId: string,
  type: string,
  closePage: Function,
}

class EditNote extends React.Component<Props> {
  formApi: {
    getState: Function,
    reset: Function,
  }

  componentDidUpdate() {
    this.formApi.reset();
  }

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  // Misc functions
  /* eslint-disable no-param-reassign */
  transformData(formValues: Object) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY, HH:mm').toISOString();
    // add active account for edit history
    const { activeAccount } = this.props;
    formValues.editor = `${activeAccount.name}, ${activeAccount.credential}`;
    formValues.editDate = moment().toISOString();
  }

  handleSave = () => {
    const formData = this.formApi.getState();
    if (formData.invalid) {
      return;
    }
    if (!Object.keys(formData.touched).length) {
      this.props.closePage();
      return;
    }
    this.transformData(formData.values);
    if (!this.props.note) {
      this.props.handleSaveNewNote(this.props.activePatientId, {
        problemId: this.props.problemId,
        ...formData.values,
      });
    } else {
      this.props.handleSaveNote(this.props.activePatientId, {
        progressNoteId: this.props.note._id,
        ...formData.values,
      });
    }
    this.props.closePage();
  }

  render() {
    const data = this.props.note || {};
    const { editors, editDates } = data;
    let editHistory = '';
    if (editors) {
      for (let i = 0; i < editors.length; i++) {
        if (i === editors.length - 1) {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]} (created) \n`;
        } else {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]}\n`;
        }
      }
    }

    return (
      <ContentBox title={`${this.props.type}`}>
        <Form getApi={this.setFormApi} autoComplete='off'>
          <div className={styles.notes}>
            <PrimaryText>Notes</PrimaryText><br />
            <TextArea field='notes' initialValue={data.notes} />
          </div>
          <table>
            <tbody>
              <tr>
                <td><PrimaryText>Exam Date </PrimaryText></td>
                <td><DatetimeText field='date' initialValue={data.date} /></td>
              </tr>
              <tr className={styles.editHistoryRow}>
                <td><strong>Edit History </strong></td>
                <td>{editHistory || '--'}</td>
              </tr>
            </tbody>
          </table>
          <PrimaryButton onClick={this.handleSave}>Save</PrimaryButton>
          <Button onClick={this.props.closePage}>Cancel</Button>
        </Form>
      </ContentBox>
    );
  }
}

const mapStateToPropsNurse = state => ({
  activePatientId: state.patient.data.activePatientId,
  activeAccount: state.account.activeAccount,
  type: NURSE_NOTE_TYPE,
});

const mapStateToPropsProvider = state => ({
  activePatientId: state.patient.data.activePatientId,
  activeAccount: state.account.activeAccount,
  type: PROVIDER_NOTE_TYPE,
});

const mapDispatchToPropsNurse = dispatch => ({
  handleSaveNewNote:
   (patientId, nurseNote) => dispatch(addNurseNote(patientId, nurseNote)),
  handleSaveNote:
   (patientId, nurseNote) => dispatch(updateNurseNote(patientId, nurseNote)),
});

const mapDispatchToPropsProvider = dispatch => ({
  handleSaveNewNote:
   (patientId, providerNote) => dispatch(addProviderNote(patientId, providerNote)),
  handleSaveNote:
   (patientId, providerNote) => dispatch(updateProviderNote(patientId, providerNote)),
});

const EditNurseNote = connect(
  mapStateToPropsNurse,
  mapDispatchToPropsNurse,
)(EditNote);

const EditProviderNote = connect(
  mapStateToPropsProvider,
  mapDispatchToPropsProvider,
)(EditNote);

export {
  EditNurseNote,
  EditProviderNote,
};



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/edit/EditNote.jsx